export const CashToggle = ({ value, canEdit = false, onToggle, testId, className = "" }) => {
  // Hide the empty (not-filled) indicator on cards for everyone except admins (canEdit).
  if (!canEdit && !value) return null;

  const dot = (
    <span
      className={`inline-block h-3.5 w-3.5 rounded-full border-2 border-border transition-colors ${value ? "bg-border" : "bg-transparent"}`}
    />
  );
  if (!canEdit) {
    return (
      <span data-testid={testId} className={`inline-flex items-center ${className}`}>
        {dot}
      </span>
    );
  }
  return (
    <button
      type="button"
      onClick={onToggle}
      data-testid={testId}
      aria-pressed={!!value}
      className={`inline-flex items-center p-0.5 rounded hover:opacity-70 transition-opacity ${className}`}
    >
      {dot}
    </button>
  );
};
